import React from "react";

export const NotFound = () => {
  return <div className="not-found">Not Found</div>;
};
